// extracted by mini-css-extract-plugin
module.exports = {"SideBar":"SideBar_SideBar__1o5Ce","NavigationItems":"SideBar_NavigationItems__G9ZJv","Open":"SideBar_Open__2xTpJ","Close":"SideBar_Close__1hXbA"};